(function() {
    'use strict';
    angular
        .module('bhsApp')
        .factory('Data', Data);

    Data.$inject = ['$resource'];

    function Data ($resource) {
        var resourceUrl =  'api/data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
